import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment-timezone'
import styled from 'styled-components'

import { mapLanguageToComponentProps } from 'i18n'
import { formatDateTime } from 'utils/date'
import { hasFeature } from 'admin/selectors/session'
import { toggleModal } from 'actions'
import { MODAL_CRONOFY_PERSONAL_INTERVIEW } from 'modals'
import { I18nComponentType } from 'i18n-types'
import { Button } from 'components/styled/button'
import { Body } from 'components/styled/typography'
import { Field } from 'components/styled/typography/field'
import { Flex } from 'components/styled/containers/flex'
import { StyledButton } from 'components/styled/button/button'

interface CalendarInvitationStatus {
  status: string
  eventStartTime: string
  eventLocation: string
}

interface StatusProps {
  i18n: I18nComponentType
  hasFeatureCalendarEnabled?: boolean
  calendarInvitationStatus?: CalendarInvitationStatus[]
  timezone?: string
  dispatch: any
}

const renderStatus = (
  i18n: I18nComponentType,
  timezone: string,
  calendarInvitationStatus: CalendarInvitationStatus
) => {
  switch (calendarInvitationStatus.status) {
    case 'sent':
      return <Body>{i18n.personDetails.scheduledInterviewInvitationSent}</Body>
    case 'eventCreated':
      return (
        <>
          <Body>
            {i18n.personDetails.scheduledInterviewInvitationEventCreated}
            {formatDateTime(calendarInvitationStatus.eventStartTime, timezone)}
            {calendarInvitationStatus.eventLocation && `(${calendarInvitationStatus.eventLocation})`}
          </Body>
        </>
      )
    case 'expired':
      return (
        <Body color="error110">
          {i18n.personDetails.scheduledInterviewInvitationExpired}
        </Body>
      )
    default:
      return ''
  }
}

const StyledWrapper = styled(Flex)`
  ${StyledButton} {
    margin-left: ${({ theme }) => theme.space.s20};
  }

  ${({ theme }) => theme.mediaQuery.screenM} {
    display: block;

    ${StyledButton} {
      margin-left: 0;
    }
  }
`

export const ScheduledInterviewStatus = ({
  i18n,
  dispatch,
  hasFeatureCalendarEnabled = false,
  calendarInvitationStatus = [],
  timezone = moment.tz.guess(),
}: StatusProps) => {
  
  if (!hasFeatureCalendarEnabled || !calendarInvitationStatus[0]) {
    return <div />
  }

  return (
    <StyledWrapper>
      <Field
        title={i18n.personDetails.scheduledInterview}
        content={renderStatus(i18n, timezone, calendarInvitationStatus[0])}
      />
      <Button
        variant="secondary"
        icon="event"
        text={i18n.personDetails.scheduledInterviewReScheduleMeeting}
        onClick={() => dispatch(toggleModal(MODAL_CRONOFY_PERSONAL_INTERVIEW))}
      />
    </StyledWrapper>
  )
}

export default connect<{
  i18n: I18nComponentType
}>(
  mapLanguageToComponentProps((state: any) => ({
    hasFeatureCalendarEnabled: hasFeature(state, 'calendar'),
  }))
)(ScheduledInterviewStatus)
